import { motion, useReducedMotion } from "framer-motion";

interface AIStackPillsProps {
  items: string[];
  eyebrow?: string;
  heading?: string;
  showLabel?: boolean;
}

const AIStackPills = ({ items, eyebrow, heading, showLabel = false }: AIStackPillsProps) => {
  const prefersReduced = useReducedMotion();

  const anim = {
    initial: prefersReduced ? { opacity: 0 } : { opacity: 0, y: 30 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, margin: "-80px" as const },
    transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] as const },
  };

  return (
    <section className="py-12">
      <div className="container mx-auto px-6">
        <motion.div
          initial={anim.initial}
          whileInView={anim.whileInView}
          viewport={anim.viewport}
          transition={anim.transition}
        >
          {eyebrow && (
            <p className="text-xs font-body font-semibold tracking-[0.2em] uppercase text-primary mb-3 text-center">
              {eyebrow}
            </p>
          )}
          {heading && (
            <h2 className="text-3xl sm:text-4xl font-display tracking-tight text-center mb-8">
              {heading}
            </h2>
          )}

          {showLabel && (
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-primary/60 text-center mb-4">
              AI_STACK/
            </p>
          )}

          <div className="flex flex-wrap justify-center gap-3 max-w-3xl mx-auto">
            {items.map((item, i) => (
              <motion.span
                key={item}
                initial={prefersReduced ? { opacity: 1 } : { opacity: 0, y: 8 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={prefersReduced ? { duration: 0.2 } : { delay: i * 0.03, duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
                className="border border-primary/60 rounded-full px-4 py-2 text-primary text-sm font-body transition-[border-color,transform,box-shadow] duration-200 [@media(pointer:fine)]:hover:border-primary/80 [@media(pointer:fine)]:hover:-translate-y-0.5"
              >
                {item}
              </motion.span>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default AIStackPills;
